import { ref as u, onMounted as v, onUnmounted as d } from "vue";
let c = null;
const l = /* @__PURE__ */ new Map();
function h() {
  return c || (c = new ResizeObserver((e) => {
    for (const n of e) {
      const r = n.target, s = l.get(r);
      if (s) {
        const i = n.contentRect.width, t = n.contentRect.height;
        s.forEach((o) => o(i, t));
      }
    }
  })), c;
}
function b(e) {
  const n = u(0), r = u(0);
  let s = null;
  const i = (t, o) => {
    n.value = t, r.value = o;
  };
  return v(() => {
    const t = h();
    if (e.value) {
      n.value = e.value.offsetWidth, r.value = e.value.offsetHeight;
      const o = e.value;
      let a = l.get(o);
      a || (a = /* @__PURE__ */ new Set(), l.set(o, a)), a.add(i), s = a, t.observe(o);
    }
  }), d(() => {
    if (e.value && s) {
      const t = e.value;
      s.delete(i), s.size === 0 && (l.delete(t), c && c.unobserve(t));
    }
  }), { width: n, height: r };
}
export {
  b as u
};
